
import { Component, Mixins } from "vue-property-decorator";
import { default as SelectableMixin } from "./SelectableMixin.vue";

@Component({
})
export default class SingleSelectableMixin extends Mixins(SelectableMixin) {
  get selectedOption(): any {
    return this.findOption(this.editingSource, this.options);
  }

  set selectedOption(option: any) {
    this.editingSource = option;
  }
}
